import {
  IRowPattern,
  SmartPairedBayBlock,
  SmartUnpairedBayBlock,
} from "@tedivo/tedivo-bay-grid-pure";
import { getAllContainersPortSide, getAllContainersStbdSide } from "./getAllContainers";

import { TGetContainersFilterOutput } from "./TGetContainersFilterOutput";
import { TSelectContainerCriteria } from "../useSimpleSideView";
import { getContainersByMaxSizePerStack } from "./getContainersByMaxSizePerStack";
import { getRowContainers } from "./getPerRowContainers";
import { getSideContainers } from "./getSideContainers";

export function obtainSideViewFilterFn(
  selectContainerCriteria: TSelectContainerCriteria,
): TObtainFilterFnOutput {
  switch (selectContainerCriteria) {
    case "maxSize":
      return getContainersByMaxSizePerStack;
    case "all":
    case "allSbtdSide":
      return getAllContainersStbdSide;
    case "allPortSide":
      return getAllContainersPortSide;
    case "portOuter":
      return getSideContainers("port");
    case "stbdOuter":
      return getSideContainers("starboard");
    default:
      return getRowContainers(selectContainerCriteria as IRowPattern);
  }
}

type TObtainFilterFnOutput = (
  smartBay: SmartUnpairedBayBlock | SmartPairedBayBlock,
) => TGetContainersFilterOutput;
